<template>
  <div class="main-content-container">
    <div
      class="top-content-container position-relative customer-details-top-content"
    >
      <b-row>
        <b-col cols="12">
          <b-breadcrumb class="customer-breadcrumbs">
            <b-breadcrumb-item v-if="$route.meta.assistants">
              <span
                @click="$router.push({ name: 'ViewPADirectory' })"
                class="text-uppercase font-family-medium"
              >
                Team Directory
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item
              v-if="$route.meta.assistants"
              @click="navigateToPAContact"
            >
              <span class="text-uppercase font-family-medium">
                {{ assistantFullname }}
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item @click="navigateToCustomersList">
              <span class="text-uppercase font-family-medium">
                Customers
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item @click="navigateToCustomerDetails">
              <span class="text-uppercase font-family-medium">
                {{ customerFullname }}
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item @click="navigateToPreferences">
              <span class="text-uppercase font-family-medium">
                Preferences
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span class="text-uppercase font-family-medium">
                View Preference
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col class="mt-4 select-category-wrapper" cols="12" lg="9">
        <b-form-group label="Select Category *" class="weekly-form-group">
          <b-form-select
            :options="categories"
            v-model="selectedCategory"
            disabled
            @change="getSelectedCategory"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="">
      <b-col class="" cols="12" lg="9">
        <ValidationObserver>
          <ValidationProvider name="rte" rules="required">
            <b-form-group
              label="Description *"
              class="weekly-form-group"
            >
              <quill-editor
                v-if="hasAllEditorConfig"
                v-model="content"
                ref="quillEditor"
                :options="prefEditorOptions"
                :disabled="isLoadingDescription || isOwnerUser"
                :class="isLoadingDescription ? 'grey-editor' : 'quill-editor'"
                class="quill-custom"
              />

              <h6
                v-if="contentValid === false"
                style="margin-bottom: -3.4rem"
                class="font-sm font-family-regular danger ml-2 mt-4"
              >
                This field is required
              </h6>
            </b-form-group>
          </ValidationProvider>
        </ValidationObserver>
      </b-col>
    </b-row>
    <b-row class="attachment-control-wrapper">
      <b-col cols="12" lg="9" class="">
        <b-form-group class="general-info-form-group" label="Attachment">
          <b-input-group class="d-flex flex-column">
            <label class="file-select font-sm">
              <div
                class="d-flex flex-row justify-content-between w-100 p-3 cursor-pointer bg--white border-primary-lighter border-radius-sm"
              >
                <h6 class="font-sm secondary--text font-family-regular mb-0">
                  Add Attachment
                </h6>
                <img
                  class="attachment-icon"
                  src="@/assets/icons/attachments.svg"
                  alt
                />
              </div>
              <input
                type="file"
                :accept="ACCEPTED_FILE_TYPES"
                hidden
                :disabled="disableFields"
                @change="fileChange"
                ref="fileInput"
                multiple
                class="d-none"
              />
            </label>
          </b-input-group>
          <h6 class="font-sm danger" v-if="sizeExceed">
            Size cannot be greater than 500MB
          </h6>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="attachments-row">
      <b-col cols="12">
        <b-form-group
          class="tasks-form-group w-100"
          label="Attachments"
          v-if="visibleAttachments.length > 0"
        >
          <div
            class="mb-5 d-flex"
            v-for="(attachment, index) in visibleAttachments"
            :key="index"
          >
            <div
              v-if="!isImage(attachment)"
              class="box-container bg--primary-light d-flex align-items-center justify-content-center"
            >
              <template v-if="!isFile(attachment)">
                <a
                  :href="attachment.attachment.attachmentFile"
                  target="_blank"
                  v-if="attachment.attachment.filetype === 'pdf'"
                >
                  <h1 class="font-lg primary--text font-family-medium">
                    {{ attachment.attachment.filetype.toUpperCase() }}
                  </h1>
                </a>
                <a
                  :download="attachment.attachment.name"
                  :title="attachment.attachment.name"
                  :href="attachment.attachment.attachmentFile"
                  v-else
                >
                  <h1 class="font-lg primary--text font-family-medium">
                    {{ attachment.attachment.filetype.toUpperCase() }}
                  </h1>
                </a>
              </template>
              <h1 v-else class="font-lg">
                <a
                  :href="URL.createObjectURL(attachment)"
                  target="_blank"
                  class="primary--text font-family-medium"
                  v-if="getFileExtension(attachment) === 'PDF'"
                >
                  {{ getFileExtension(attachment) }}</a
                >
                <a
                  :title="attachment.name"
                  class="primary--text font-family-medium"
                  :href="URL.createObjectURL(attachment)"
                  :download="attachment.name"
                  v-else
                >
                  {{ getFileExtension(attachment) }}
                </a>
              </h1>
            </div>
            <div
              v-else
              @click="onThumbnailClick(attachment, index)"
              class="box-container bg--primary-light d-flex align-items-center justify-content-center thumbnail-wrapper"
            >
              <img
                :src="attachment.attachment.thumbnail"
                v-if="attachment.attachment"
              />
              <img :src="URL.createObjectURL(attachment)" v-else />
            </div>
            <div
              class="col d-flex flex-column justify-content-center text-align-center"
            >
              <p
                class="primary--text font-family-medium position-relative attachment-text"
                v-if="attachment.attachment"
              >
                {{ `${attachment.attachment.filename}` }}
                <!-- {{ attachment.attachment.filename }} -->
              </p>
              <p class="primary--text font-family-medium" v-if="attachment.name">
                {{ `${attachment.name}` }}
              </p>
              <div>
                <b-button
                  class="btn-pill btn-danger px-4 attachment-delete-btn"
                  @click="deletePrefAttachment(index)"
                  :disabled="disableFields"
                >
                  Delete
                </b-button>
              </div>
            </div>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="checklist-row">
      <b-col cols="12" lg="9">
        <b-form-group
          label="Checklists"
          class="tasks-form-group"
          v-if="checklists.length"
        >
          <ChecklistComponent
            :checklists="checklists"
            :isFormEnabled="true"
            :checkboxDisabled="true"
            @saveOption="saveChecklistOption"
            @saveTitle="saveChecklistTitle"
            @deleteChecklist="deleteChecklist"
            @deleteOption="removeOption"
            @updateChecklist="patchChecklist"
            class="mb-5"
          />
        </b-form-group>
        <b-form-group
          class="mb-5 mt-5 add-view-category-form-group"
          label="Checklist"
          v-else
        >
          <b-input-group @keyup.enter="onChecklistInputEnter">
            <b-form-input
              :disabled="disableFields"
              autocomplete="off"
              class="add-category-check checklist-input"
              size="lg"
              v-model="checklistValue"
              placeholder="Add checklist"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="position-relative ml-1">
        <b-alert
          class="alert-btn-top custom-alert"
          v-if="showAlert"
          show
          :fade="true"
          >{{ alertMsg }}</b-alert
        >
      </b-col>
    </b-row>
    <b-row class="save-button-row" v-if="!isOwnerUser">
      <b-col>
        <b-button 
          @click="deleteModal.visible = true"
          class="btn-pill py-3 px-5 btn-danger"
        >
          Delete
          </b-button>
      </b-col>
    </b-row>
    <b-modal
      size="lg"
      centered
      v-model="previewModal.visible"
      content-class="preview-modal"
      :hide-header="true"
      :hide-footer="true"
    >
      <div class="preview-modal-header">
        <div class="header-text">{{ previewModalData.title }}</div>
        <b-button id="delete-button" @click="onDeleteImage">Delete</b-button>
        <b-button
          id="download-button"
          @click="onPreviewModalDownload"
          :disabled="isLoading"
          >Download</b-button
        >
        <b-button id="close-button" @click="previewModal.visible = false">
          <img src="@/assets/icons/close_sidebar.svg" />
        </b-button>
        <a
          :href="previewModalData.src"
          :title="previewModalData.title"
          :download="previewModalData.title"
          :style="{ display: 'none' }"
          ref="downloadAnchor"
        ></a>
      </div>
      <div class="preview-modal-image-wrapper">
        <img :src="previewModalData.src" />
      </div>
    </b-modal>
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      v-model="errorModal.visible"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-container fluid>
        <b-button
          @click="errorModal.visible = false"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row align-v="center" class="px-2 py-2">
          <b-col md="9" class="d-flex mb-2">
            <h4 class="font-md subtext mt-2">
              {{ errorModal.message }}
            </h4>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      centered
      body-class="delete-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="deleteModal.visible"
    >
      <b-container fluid>
        <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt @click="deleteModal.visible = false"/>
        <b-row
          class="pt-2 mb-5 d-flex flex-column"
          :style="{ paddingLeft: '15px' }"
        >
          <h2
            class="modal_header font-md"
            :style="{ marginBottom: 0 }"
          >
            Are you sure?
          </h2>
          <h4  class="font-md subtext">
            Do you want to delete this preference?
          </h4>
        </b-row>
        <b-row align-v="center">
          <b-button
            :style="{ marginLeft: 'auto' }"
            @click="deletePreference"
            :disabled="deleting"
            class="btn-danger px-5 py-3 mr-5 btn-pill reduce-whitespace"
          >
            <b-spinner
              v-if="deleting"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            <template v-else> Delete </template>
          </b-button>
        </b-row>
      </b-container>
    </b-modal>
    <SaveIndicator ref='saveIndicator'/>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { isFile, getFileExtension, isImage, isOwner } from "@/utils/utils";
import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate/dist/vee-validate.full";
import { getCategories, postAttachments } from "@/apis/common";
import useUndoRedo from "@/utils/undo-redo-utils"
import {
  deletePreference,
  deletePreferenceAttachment,
  deletePreferenceChecklist,
  deletePreferenceChecklistOption,
  getCustomer,
  getPreference,
  getPreferenceChecklist,
  patchPreferenceChecklist,
  patchPreferences,
  postPreferenceCheckList,
  postPreferenceChecklistOption,
  postPreferencesAttachment
} from "@/apis/customers";
import SaveIndicator from '@/components/indicators/SaveIndicator'
import { editorOptions, DEBOUNCE_DELAY, ACCEPTED_FILE_TYPES } from '@/utils/constants'
import _ from 'lodash'
import { mapState } from "vuex";
import { getAssistantDetails } from "@/apis/assistants";
import ChecklistComponent from "@/components/checklists/ChecklistComponent";
export default {
  name: "ViewEditPreference",
  components: {
    ValidationObserver,
    ValidationProvider,
    SaveIndicator,
    quillEditor,
    ChecklistComponent
  },
  computed: {
    quillInstance() {
      return this.$refs.quillEditor.quill
    },

    hasAllEditorConfig() {
      // * This is needed as the quil editor here is loaded during the mounting process,
      // * whereas in `ViewTask.vue`, the method `getEditorOptions` is call before (in the `mounted` hook)
      // * the editor is mounted. Hence, in `ViewTask.vue`there is no need to check for the customisation
      // * of the editor's options.
      return this.prefEditorOptions
        && this.prefEditorOptions.modules
        && this.prefEditorOptions.modules.toolbar
        && this.prefEditorOptions.modules.toolbar.container
        && this.prefEditorOptions.modules.toolbar.container.find(item => {
          return item[0] === "myUndo" && item[1] === "myRedo"
        })
    },
    isOwnerUser() {
      return isOwner();
    },
    disableFields() {
      // Owners view preferences read-only; the API refuses their writes.
      return this.isLoading || this.isOwnerUser;
    },
    previewModalData() {
      let { previewModal } = this;
      if (!previewModal.attachment) {
        return {
          src: "",
          title: "",
          thumbnail: ""
        };
      }
      if (previewModal.attachment instanceof File) {
        let blobUrl = window.URL.createObjectURL(previewModal.attachment);
        return {
          src: blobUrl,
          title: previewModal.attachment.name,
          thumbnail: blobUrl
        };
      }
      return {
        src: previewModal.attachment.attachment.attachmentFile,
        title: previewModal.attachment.attachment.filename,
        thumbnail: previewModal.attachment.attachment.thumbnail
      };
    },
    visibleAttachments() {
      // * don't show attachments that are to be deleted
      // * they will be deleted form the backend if the user clicks on the save button
      return this.attachments.filter(attachment => !attachment.toBeDeleted);
    },

    ...mapState("authModule", ["role", "profileUserId"])
  },
  created() {
    this.trackPreferenceView();
    this.preferenceID = this.$route.params.prefID;

    this.initialiseUndoRedo(this.preferenceID)

    this.fetchCategoryList();
    this.customerID = this.$route.params.profileId;
    if (this.$route.params.customerFullname) {
      this.customerFullname = this.$route.params.customerFullname;
    } else {
      getCustomer(this.$route.params.profileId)
        .then(res => {
          let { firstName, lastName } = res.data.user;
          this.customerFullname = `${firstName} ${lastName}`;
        })
        .catch(err => console.log(err));
    }
    if (
      this.$route.params.assistantFullname &&
      this.$route.name === "PAViewPreference"
    ) {
      this.assistantFullname = this.$route.params.assistantFullname;
    } else if (
      !this.$route.params.assistantFullname &&
      this.$route.params.uuid
    ) {
      getAssistantDetails(this.$route.params.uuid)
        .then(res => {
          let { firstName, lastName } = res.data.user;
          this.assistantFullname = `${firstName} ${lastName}`;
        })
        .catch(err => console.log(err));
    }

  },
  data() {
    return {
      ACCEPTED_FILE_TYPES,
      errorModal: {
        visible: false,
        message: "File is empty. Cannot upload"
      },
      deleteModal: {
        visible: false
      },
      deleting: false,
      URL: window.URL,
      previewModal: {
        visible: false,
        src: "",
        attachment: null
      },
      sizeExceed: false,
      customerFullname: "",
      assistantFullname: "",
      categories: [{ text: "Select Category", value: null }],
      selectedCategory: null,
      showAlert: false,
      isLoading: false,
      isLoadingDescription: true,
      content: "",
      saveBtnText: "Save",
      customerID: "",
      categoryValid: "",
      preferenceID: "",
      attachments: [],
      editorOptions,
      prefEditorOptions: {},
      undoRedoPressed: false,
      contentValid: null,
      checklists: [],
      checklistValue: null
    };
  },
  mounted() {
    getPreference(this.customerID, this.preferenceID).then(res => {
      this.selectedCategory = res.data.categories[0].id;
      this.content = res.data.detail;
      this.isLoadingDescription = false

      this.attachments = [...res.data.attachments];
      this.getChecklists();
      this.$nextTick(() => {
        this.$refs?.quillEditor?.$on('change', this.onEditorChange)
      })
    });
    this.onEditorChange = _.debounce(this.onEditorChange, DEBOUNCE_DELAY)
    this.showSaveIndicator = this.$refs.saveIndicator.showSaveIndicator
    this.showSaveIndicatorSaved = this.$refs.saveIndicator.showSaveIndicatorSaved
    this.showSaveIndicatorError = this.$refs.saveIndicator.showSaveIndicatorError

    this.getEditorOptions()
  },
  methods: {
    isFile,
    getFileExtension,
    isImage,
    trackPreferenceView() {
      this.$gtag.event("Preference - View", {
        event_category: "feature"
      });
    },
    trackPreferenceUpdate() {
      this.$gtag.event("Preference - Update", {
        event_category: "feature"
      });
    },
    trackPreferenceDelete() {
      this.$gtag.event("Preference - Delete", {
        event_category: "feature"
      });
    },
    async deletePreference() {
      this.trackPreferenceDelete();
      this.deleting = true
      try {
        await deletePreference(this.customerID, this.preferenceID)
        this.$router.go(-1)
      } catch(e) {
        this.showSaveIndicatorError()
      } finally {
        this.deleteModal.visible = false
        this.deleting = false
      }
    },
    navigateToCustomersList() {
      if (this.role === "assistant" && this.$route.meta.customers) {
        this.$router.push({
          name: "DedicatedCustomers"
        });
      } else if (this.role === "admin" && this.$route.meta.customers) {
        this.$router.push({
          name: "CustomersListAdmin",
          query: {
            tab: 0
          }
        });
      } else if (
        (this.role === "assistant" || this.role === "admin") &&
        this.$route.meta.assistants
      ) {
        this.$router.push({
          name: "PADetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 2
          }
        });
      }
    },
    navigateToCustomerDetails() {
      if (this.$route.meta.customers) {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 2
          }
        });
      } else if (this.$route.meta.assistants) {
        this.$router.push({
          name: "PACustomerDetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 2
          }
        });
      }
    },
    navigateToPreferences() {
      if (this.$route.meta.customers) {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 1
          }
        });
      } else if (this.$route.meta.assistants) {
        this.$router.push({
          name: "PACustomerDetails",
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          query: {
            tab: 1
          }
        });
      }
    },
    navigateToPAContact() {
      this.$router.push({
        name: "PADetails",
        params: {
          profileId: this.$route.params.profileId,
          uuid: this.$route.params.uuid
        },
        query: {
          tab: 1
        }
      });
    },
    fetchCategoryList() {
      getCategories()
        .then(res => {
          this.categories = [...res.data.results].map(item => {
            item.text = item.title;
            item.value = item.id;
            return item;
          });
          this.categories.unshift({
            text: "Select Category",
            value: null
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSelectedCategory() {},
    removeSelectedCategory() {},
    onEditorChange() {
      let strippedContent = this.content.replace(/<(.|\n)*?>/g, "").trim();

      if (strippedContent.length === 0) {
        this.contentValid = false;
      } else {
        this.contentValid = true;
      }

      if (this.contentValid) {
        this.patchPreference()
      }
    },
    getEditorOptions() {
      let tempOptions = _.cloneDeep(editorOptions)
      tempOptions.modules.toolbar.container.push(["myUndo", "myRedo"])
      tempOptions.modules.toolbar.handlers = {
        myUndo: this.onUndoTaskDescription,
      myRedo: this.onRedoTaskDescription
      }
      this.prefEditorOptions = { ...tempOptions }
    },

    onUndoTaskDescription() { this.undoRedoHandler("undo") },

    onRedoTaskDescription() { this.undoRedoHandler("redo") },
    
    undoRedoHandler(action) {
      const { onUndoRedoHander } = useUndoRedo()
      const {
        noPointer,
        undoRedoPressed,
        description
      } = onUndoRedoHander(
        this.preferenceID,
        "customerPrefHistoryPrefix-",
        action
      )

      if (noPointer) { return false }

      this.undoRedoPressed = undoRedoPressed
      this.content = description

      // * Note that the changes are handled by `onEditorChange()`.
    },

    addUndoRedoStep(content) {
      const { setDataAndPointer, updateUndoRedoData } = useUndoRedo()
      
      const MAX_UNDO_STEPS = 15
      const { data, pointer } = setDataAndPointer(
        MAX_UNDO_STEPS, this.preferenceID, "customerPrefHistoryPrefix-"
      )

      const lastEntry = data[data.length - 1]

      const lastEntryIsIdentical = lastEntry?.content === content
      if (lastEntryIsIdentical) {
        console.warn("Is identical, skipping")
        return
      }

      data.push({ content: this.content })
      updateUndoRedoData(data, pointer, this.preferenceID, "customerPrefHistoryPrefix-")
    },

    initialiseUndoRedo(itemId) {
      const { clearAllPreviousHistory } = useUndoRedo()
      clearAllPreviousHistory(itemId)

      // * Note that here we are watching for a specific `this.isLoadingDescription`,
      // * which was added to only track for when the description gets loaded.
      // * This was done to avoid disturbing the global `this.isLoading` which is set
      // * to `false` initially.
      const unregisterTheWatcher = this.$watch('isLoadingDescription', (isLoading) => {
        if (!isLoading && this.content) {
          this.addUndoRedoStep(this.content)
          unregisterTheWatcher()
        }
      })
    },

    async patchPreference() {
      this.trackPreferenceUpdate();
      this.showAlert = false;
      let strippedContent = this.content.replace(/<(.|\n)*?>/g, "").trim();
      if (strippedContent.length === 0) {
        this.contentValid = false;
      } else {
        this.contentValid = true;
      }
      if (this.selectedCategory === null) {
        this.categoryValid = false;
      } else {
        this.categoryValid = true;
      }
      if (this.selectedCategory !== null && this.contentValid) {
        this.isLoading = true;
        this.showSaveIndicator()
        const data = {
          profile: this.customerID,
          detail: this.content,
          categories: [this.selectedCategory]
        };
        try {
          let res = await patchPreferences(
            this.customerID,
            this.preferenceID,
            data
          );
          this.preferenceID = res.data.id;
          this.showSaveIndicatorSaved()
          /*
            case 1: isFile and toBeDeleted - N/A
            case 2: isFile and !toBeDeleted - upload
            case 3: !isFile and toBeDeleted - delete API
            case 4: !isFile and !toBeDeleted - do nothing
            */

          this.undoRedoPressed
              ? (this.undoRedoPressed = false)
              : this.addUndoRedoStep(this.content)
        } catch (err) {
          console.log(err);
          this.showSaveIndicatorError()
          if (err?.response?.status === 401) {
            this.showAlert = true;
            this.alertMsg = "User token expired. Please logout and login again";
          }
        } finally {
          this.isLoading = false;
        }
      } else {
        this.showAlert = true;
        this.alertMsg = "There are invalid form fields";
      }
    },
    async uploadAttachment(attachment) {
      let myFile = new File([attachment], `${attachment.name}`);
      const formData = new FormData();
      formData.append("owner", this.profileUserId);
      formData.append("attachmentFile", myFile);
      let res = await postAttachments(formData);
      const data = {
        preference: this.preferenceID,
        attachment: res.data.id
      };
      let apiResponse = await postPreferencesAttachment(this.customerID, this.preferenceID, data);
      this.attachments.push({
        ...apiResponse.data,
        attachment: res.data
      });
      return true
    },
    async deletePrefAttachment(index) {
      let attachment = this.visibleAttachments[index];
      this.showSaveIndicator() 
      this.isLoading = true
      try {
        await deletePreferenceAttachment(this.customerID, this.preferenceID, attachment.id)
        this.showSaveIndicatorSaved()
        this.attachments = this.attachments.filter((attachment, _index) => index !== _index)
      } catch(e) {
        console.log(e)
        this.showSaveIndicatorError() 
      } finally {
        this.isLoading = false
      }
    },
    fileChange(event) {
      const extensions = this.ACCEPTED_FILE_TYPES
        .split(",")
        .filter(item => item[0] === '.');

      let sizing = true;
      this.sizeExceed = false;
      for (let i = 0; i < event.target.files.length; i++) {
        if (event.target.files[i].size / 1024 / 1024 > 500) {
          sizing = false;
          break;
        }
      }
      // * empty file validation
      for (let file of event.target.files) {
        const fileExtension = `.${file.name.split(".").reverse()[0]}`
        const isRestrictedFileType = !extensions.includes(fileExtension)
        if (isRestrictedFileType) {
          this.errorModal.message = `${file.name} file format is not supported, please contact admin for more details.`;
          this.errorModal.visible = true;
          this.$refs.fileInput.value = "";
          return;
        }

        if (file.size === 0) {
          this.errorModal.message = `${file.name} is empty. Cannot upload.`;
          this.errorModal.visible = true;
          this.$refs.fileInput.value = "";
          return;
        }
      }
      let promises = []
      if (sizing) {
        this.showSaveIndicator()
        this.isLoading = true
        for (let i = 0; i < event.target.files.length; i++) {
          let file = event.target.files[i]
          let promise = this.uploadAttachment(file)
          promises.push(promise)
          Promise.all(promises).then(() => {
            this.showSaveIndicatorSaved()
          }).catch(() => {
            this.showSaveIndicatorError()
          }).finally(() => {
            this.isLoading = false
          })
        }
      } else {
        this.sizeExceed = true;
      }
      this.$refs.fileInput.value = "";
    },
    onPreviewModalDownload() {
      // * forcibly download the file
      this.$refs.downloadAnchor.click();
    },
    onThumbnailClick(attachment, attachmentIndex) {
      this.previewModal.attachment = attachment;
      this.previewModal.attachmentIndex = attachmentIndex;
      this.previewModal.visible = true;
    },
    onDeleteImage() {
      let { attachmentIndex } = this.previewModal;
      this.deletePrefAttachment(attachmentIndex);
      this.previewModal.visible = false;
    },
    getChecklists() {
      getPreferenceChecklist(this.preferenceID)
        .then(res => {
          let sortedChecklists = res?.data?.results.map(checklist =>
            this.sortChecklistByPosition(checklist)
          );
        this.checklists = sortedChecklists;
        })
        .catch(() => {
          this.showSaveIndicatorError();
        })
        .finally();
    },
    sortChecklistByPosition(checklist) {
      let sortedChecklist = _.cloneDeep(checklist);
      sortedChecklist.options = [];
      checklist?.options.forEach(option => {
        sortedChecklist.options[option.position] = option;
      });
      sortedChecklist.options = sortedChecklist.options.filter(
        value => value !== undefined
      );
      return sortedChecklist;
    },
    saveChecklistOption(option, checklistIndex, optionIndex, isNewOption) {
      if (!option.length > 0) {
        return;
      }
      let data;
      if (isNewOption) {
        data = { title: option };
        this.showSaveIndicator();
        postPreferenceChecklistOption(
          this.preferenceID,
          this.checklists[checklistIndex].id,
          data
        )
          .then(res => {
            let option = res.data;
            this.checklists[checklistIndex].options.push({
              title: option.title,
              position: option.position,
              description: option.description,
              id: option.id
            });
            this.showSaveIndicatorSaved();
          })
          .catch(() => {
            this.showSaveIndicatorError();
          })
          .finally();
      } else {
        this.$set(
          this.checklists[checklistIndex].options[optionIndex],
          "isEditing",
          false
        );
        data = this.checklists[checklistIndex];
        this.patchChecklist(data);
      }
    },
    saveChecklistTitle() {
      let checklist = this.checklist
      if (this.newChecklistTitle.length > 0) {
        checklist.title = this.newChecklistTitle;
      }
      this.$set(checklist, "isEditingTitle", false);
    },
    deleteChecklist(index) {
      this.showSaveIndicator();
      this.deleteModal.visible = false;
      deletePreferenceChecklist(this.preferenceID, this.checklists[index].id)
        .then(() => {
          this.checklists = [];
          this.showSaveIndicatorSaved();
        })
        .catch(() => {
          this.showSaveIndicatorError();
        });
    },
    removeOption(checklist, index) {
      this.showSaveIndicator();
      this.apiLoading = true;
      const data = [{ id: this.checklists[checklist].options[index].id }];
      deletePreferenceChecklistOption(
        this.preferenceID,
        this.checklists[checklist].id,
        data
      )
        .then(() => {
          this.checklists[checklist].options.splice(index, 1);
          this.showSaveIndicatorSaved();
        })
        .catch(() => {
          this.showSaveIndicatorError();
        })
        .finally(() => {
          this.apiLoading = false;
        });
    },
    onChecklistInputEnter() {
      if (this.checklistValue !== "") {
        this.createChecklist();
      }
    },
    createChecklist() {
      this.showSaveIndicator();
      let options = [];
      let payload = {
        title: this.checklistValue,
        options: options
      };
      postPreferenceCheckList(this.preferenceID, payload)
        .then(res => {
          this.checklists.push(res.data);
          this.showSaveIndicatorSaved();
        })
        .catch(() => {
          this.showSaveIndicatorError();
        });
    },
    patchChecklist(data) {
      this.showSaveIndicator();
      patchPreferenceChecklist(this.preferenceID, data.id, {
        options: data.options
      })
        .then(() => {
          this.showSaveIndicatorSaved();
        })
        .catch(e => {
          console.log(e);
          this.showSaveIndicatorError();
        });
    },
  }
};
</script>

<style scoped lang="scss">
$row-padding: 5rem;
fieldset {
  margin-bottom: 0;
}
.attachment-control-wrapper {
  padding-top: calc(#{$row-padding});
  padding-bottom: $row-padding;
  label {
    margin-bottom: 0;
  }
}
.save-button-row {
  padding-bottom: $row-padding;
  padding-top: 0rem;
}
.select-category-wrapper {
  padding-bottom: 3.4rem;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.attachments-row {
  .box-container {
    width: 17rem;
  }
}
.close-icon {
  right: -2.2rem;
  top: -2rem;
  position: absolute;
  cursor: pointer;
  background: none;
}
::v-deep div.delete-modal {
  padding-bottom: 2rem;
}
::v-deep .checklist-option-container > p {
  line-height: 3rem;
}
</style>
<style lang="scss">
.close-wrapper {
  padding-top: 5px;
}
</style>
